import { Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MessagesService } from '../../services/messages.service';

@Component({
  selector: 'app-modal-confirm-action',
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogContent,
    MatDialogClose,
    MatIconModule,
  ],
  templateUrl: './modal-confirm-action.component.html',
  styleUrl: './modal-confirm-action.component.css'
})
export class ModalConfirmActionComponent {

  readonly dialog = inject(MatDialog);
  @Input() dialogRef: MatDialogRef<ModalConfirmActionComponent> = inject(MatDialogRef);

  constructor(
    public messagesService: MessagesService
  ) { 
  }

  cancelAction() {
    this.dialogRef.close(false);
  }

  confirmAction() {
    /*this.messagesService.pushNotification(
      `Akcja została potwierdzona`, 'info', 5000);*/
    this.dialogRef.close(true);
  }


}
